// @flow
import { CRUISE_BOOKING } from 'Client/cms/toolkit/constants';
import { CruiseBookingLine } from 'Components/lines/cruise-booking-line/CruiseBookingLine.jsx';
import { cruiseBookingResolver } from './cruiseBooking.resolver';

export const cruiseBookingDescriptor = {
  name: CRUISE_BOOKING,
  component: CruiseBookingLine,
  resolve: cruiseBookingResolver.resolve,
};
